/* Bridges native Shopify Spark List signups (tagged sparklist) into MailerLite's hidden embedded form.
   Fails silently at every step: if the MailerLite form never renders, the native Shopify submission still goes through. */
(function () {
  function bridgeToMailerLite(email, done) {
    var attempts = 0;
    function tryBridge() {
      var container = document.getElementById('ml-embedded-sparklist');
      var form = container && container.querySelector('form');
      var emailInput = form && form.querySelector('input[type="email"]');
      if (form && emailInput) {
        try {
          emailInput.value = email;
          emailInput.dispatchEvent(new Event('input', { bubbles: true }));
          emailInput.dispatchEvent(new Event('change', { bubbles: true }));
          var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
          if (submitBtn) { submitBtn.click(); } else if (form.requestSubmit) { form.requestSubmit(); }
        } catch (e) {}
        done();
        return;
      }
      attempts++;
      if (attempts < 15) { setTimeout(tryBridge, 100); } else { done(); }
    }
    tryBridge();
  }
  function wireForm(form) {
    if (!form || form.dataset.mlBridged) return;
    form.dataset.mlBridged = '1';
    form.addEventListener('submit', function (evt) {
      var emailField = form.querySelector('input[name="contact[email]"]');
      var email = emailField ? emailField.value : '';
      if (!email) return;
      evt.preventDefault();
      bridgeToMailerLite(email, function () {
        setTimeout(function () { HTMLFormElement.prototype.submit.call(form); }, 150);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('input[name="contact[tags]"][value="sparklist"]').forEach(function (input) {
      wireForm(input.closest('form'));
    });
  });
})();